import React, { useMemo } from 'react';
import { useCombinedRefs } from '../../util';
import { InternalProvider } from '../../util/InternalProvider';
import { CardIcon } from './elements';
export var PaymentBadge = React.forwardRef(function (_a, fRef) {
    var badgeType = _a.badgeType, disabled = _a.disabled, height = _a.height, width = _a.width, altText = _a.altText;
    var assetUrl = useMemo(function () {
        return "https://assets.asurion-ui.my.asurion53.com/images/badges/payment/".concat(badgeType, ".svg");
    }, [badgeType]);
    var innerRef = React.useRef();
    var combinedRef = useCombinedRefs(fRef, innerRef);
    return (React.createElement(InternalProvider, null,
        React.createElement(CardIcon, { ref: combinedRef, height: height, width: width, className: "".concat(disabled ? 'is-disabled' : ''), src: assetUrl, alt: altText === 'placeholder'
                ? 'Payment Badge Icon'
                : "".concat(altText, " Card") })));
});
PaymentBadge.defaultProps = { badgeType: 'generic' };
